import type { Meta, StoryObj } from "@storybook/react";

import type { SMTUploadBannerProps } from "@/ui/components/smt/SMTUploadBanner";
import SMTUploadBanner from "@/ui/components/smt/SMTUploadBanner";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<SMTUploadBannerProps> = {
  title: "Components/SMT/Upload Banner",
  component: SMTUploadBanner,
  argTypes: {
    photoUri: { control: "text" },
  },
  args: {
    photoUri: "https://picsum.photos/200",
  },
  render: (props) => (
    <Box width="100%">
      <SMTUploadBanner {...props} />
    </Box>
  ),
};

type Story = StoryObj<SMTUploadBannerProps>;

const WithPhoto: Story = {
  args: {
    photoUri: "https://picsum.photos/200",
  },
  name: "With Photo",
};

const WithoutPhoto: Story = {
  args: {
    photoUri: undefined,
  },
  name: "Without Photo",
};

export { WithoutPhoto, WithPhoto };
export default StoryMeta;
